import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRightCircle } from "lucide-react";
import { fetchPricesOnChain } from "../../utils/fetchPrices";

// Structure de départ
const EMPTY = { NAU: NaN, NAUY: NaN, NAUN: NaN };

const Price: React.FC = () => {
  const [prices, setPrices] = useState<typeof EMPTY>(EMPTY);
  const [error, setError] = useState<string | null>(null);

  const loadPrices = async () => {
    const result = await fetchPricesOnChain();
    if (!result) {
      setError("Unable to fetch token prices");
      return;
    }
    setPrices({
      NAU: result.priceNAU,
      NAUY: result.priceNAUY,
      NAUN: result.priceNAUN,
    });
    setError(null);
  };

  useEffect(() => {
    loadPrices();
    const id = setInterval(loadPrices, 20000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="bg-[#0d1b2a]/90 backdrop-blur-md border border-white/20 text-white shadow-2xl p-2 w-full">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-xs font-bold uppercase tracking-widest text-red-400">
          T.W.A.P<span className="text-gray-400">*</span> (Avg Price)
        </h2>
      </div>

      {error ? (
        <p className="text-center text-xs text-red-500">{error}</p>
      ) : (
        <ul className="space-y-2 text-xs text-center">
          {(
            [
              ["NAU", prices.NAU, "bg-black/30"],
              ["NAUY", prices.NAUY, "bg-blue-600/30"],
              ["NAUN", prices.NAUN, "bg-red-600/30"],
            ] as const
          ).map(([label, value, bg]) => (
            <li
              key={label}
              className={`${bg} flex justify-between items-center px-1 py-1 rounded`}
            >
              <span className="flex items-center gap-2 font-medium">
                <ArrowRightCircle size={14} />
                {label}
              </span>
              <motion.span
                key={value}
                initial={{ opacity: 0.3, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
                className="flex items-center gap-1 tracking-widest"
              >
                {isNaN(value) ? "—" : value.toFixed(4)}
              </motion.span>
            </li>
          ))}
        </ul>
      )}

      <p className="text-[12px] text-gray-400 mt-4">
        *Time-Weighted Average Price (T.W.A.P)
      </p>
    </div>
  );
};

export default Price;
